<template>
  <div style="padding: 20px">
    <Form
      :model="searchData"
      inline
      @submit.native.prevent="getCourseStore(1)"
      :label-width="50"
    >
      <FormItem label="名称">
        <Input v-model="searchData.name" clearable />
      </FormItem>
      <FormItem label="级别">
        <Select
          v-model="searchData.grade_id"
          filterable
          clearable
          placeholder="请选择级别"
          style="width: 180px"
        >
          <Option
            v-for="item in scopeGradeList"
            :key="item.id"
            :value="item.id"
            >{{ item.name }}</Option
          >
        </Select>
      </FormItem>
      <FormItem label="科目">
        <Select
          v-model="searchData.subject_id"
          filterable
          clearable
          placeholder="请选择科目"
          style="width: 180px"
        >
          <Option
            v-for="item in scopeSubjectList"
            :key="item.id"
            :value="item.id"
            >{{ item.name }}</Option
          >
        </Select>
      </FormItem>
      <div style="display: inline-block; margin-left: 10px">
        <Button type="primary" icon="ios-search" html-type="submit"
          >搜索</Button
        >
      </div>
    </Form>
    <Table
      :columns="tableColumns"
      :data="seeDetailList"
      border
      style="margin: 10px 0;min-height:50vh"
    >
      <!-- <template slot-scope="{ row }" slot="is_buy">
        {{ row.is_buy == 1 ? "是" : "需要购买" }}
      </template> -->
      <template slot-scope="{ row }" slot="is_free">
        {{ row.is_free == 1 ? "是" : "否" }}
      </template>
      <template slot-scope="{ row }" slot="index">
        {{ (tableData.current_page - 1) * 10 + row._index + 1 }}
      </template>
      <template slot-scope="{ row }" slot="is_display">
        {{ row.is_display == 2 ? "是" : "否" }}
      </template>
      <template slot-scope="{ row }" slot="action">
        <div>
          <Button
            type="warning"
            v-if="row.is_buy == 1"
            size="small"
            @click="pingjia(row)"
            style="min-height: 20px; margin-bottom: 2px;"
            >评分</Button
          >
          <!-- <Button @click="$router.push('examinationBank/paperLibrary?id='+row.id)" v-if="row.is_add == 1" type="info" size="small">查看</Button> -->
          <Button
            type="info"
            v-if="row.is_buy == 1"
            @click="seeCourse(row)"
            size="small"
            style="min-height: 20px;"
            >查看</Button
          >

          <Poptip
            v-auth="'admin/delete'"
            transfer
            confirm
            title="您确定要购买该课件库吗？"
            @on-ok="addSure(row)"
            style="min-height: 20px;"
          >
            <Button type="primary" v-if="row.is_buy != 1" size="small"
              >购买</Button
            >
          </Poptip>
        </div>
      </template>
    </Table>
    <Modal
      v-model="pingjiashow"
      title="评分"
      @on-cancel="pingjiashow = false"
      @on-ok="pingjiaOK"
    >
      <Rate v-model="pjobj.score" :count="10"></Rate>
    </Modal>
    <Page
      style="text-align: right"
      :total="tableData.total"
      :page-size="tableData.per_page"
      :current="tableData.current_page"
      show-total
      @on-change="getCourseStore"
    />
    <detailModal ref="detailModal" />
  </div>
</template>
<script>
import { mapState } from "vuex";
import detailModal from "./detailModal";
import scopeSearch from "../../mixins/scopeSearch";
export default {
  mixins: [scopeSearch],
  computed: {
    ...mapState({
      subjectList(state) {
        return state.global.subjectList;
      },
      curseList(state) {
        this.curseLists = state.global.curseList;
      }
    })
  },
  mounted() {
    this.scopeSearchInit();
    this.$store.dispatch("global/getAllSelect");
    this.$nextTick(function() {
      this.getCourseStore(1);
    });
  },
  components: {
    detailModal
  },
  data() {
    return {
      pingjiashow: false,
      pjobj: {
        score: 0
      },
      seeModal: false,
      seeDetailList: [],
      searchData: {
        name: "",
        grade_id: "",
        subject_id: ""
      },
      curseLists: [],
      tableData: {
        total: 0,
        per_page: 10,
        current_page: 1,
        last_page: 1,
        data: []
      },
      tableColumns: [
        { title: "序号", slot: "index", width: 80, align: "center" },
        {
          title: "课件库名称",
          key: "name",
          align: "center",
          minWidth: 200,
          tooltip: true
        },
        { title: "课件数量", key: "count", align: "center", minWidth: 140 },
        { title: "级别", key: "grade_name", align: "center", minWidth: 140 },
        {
          title: "科目",
          key: "subject_id",
          align: "center",
          minWidth: 140,
          render: (h, params) => {
            let [str, id] = ["", params.row.subject_id];
            this.subjectList.forEach(ele => {
              if (ele.id == id) {
                str = ele.name;
              }
            });
            return h("div", str);
          }
        },
        //   {
        //     title: "课程",
        //     key: "course_name",
        //     align: "center",
        //     minWidth: 140,
        //     tooltip: true,
        //   },
        {
          title: "课程页面",
          key: "course_img",
          align: "center",
          minWidth: 140,
          render: (h, params) => {
            return h("img", {
              attrs: {
                src: `${process.env.VUE_APP_SERVER_DOMAIN}${params.row.image}`
              },
              style: {
                width: "40px"
              }
            });
          }
        },
        {
          title: "原价",
          key: "original_price",
          minWidth: 140,
          align: "center"
        },
        { title: "现价", key: "current_price", minWidth: 140, align: "center" },
        { title: "备注", key: "remark", align: "center", minWidth: 160 },
        { title: "操作", slot: "action", minWidth: 150, align: "center" }
      ]
    };
  },
  methods: {
    pingjia(row) {
      this.pingjiashow = true;
      this.pjobj.storage_id = row.id;
      this.pjobj.type = 4;
      this.pjobj.score = row.self_score;
    },
    pingjiaOK() {
      this.$axios.post("/app/comment/addData", this.pjobj).then(res => {
        if (res.code == 1) {
          this.getCourseStore(this.tableData.current_page);
          this.$Message.success("评价成功");
          this.pingjiashow = false;
        } else {
          this.$Message.info(res.msg);
        }
      });
    },
    getcurse() {
      this.$axios
        .get("/app/curse/getList", {
          grade_id: this.searchData.grade_id,
          subject_id: this.searchData.subject_id
        })
        .then(res => {
          if (res.code == 1) {
            this.curseLists = res.data;
          } else {
            this.$Message.error(res.msg);
          }
        });
    },
    // 获取课程列表
    getCourseStore(page) {
      let data = this.searchData;
      data.current = page;
      this.$axios
        .get("/app/source_courseware_storage/index", data)
        .then(res => {
          let rec = res.data.data;
          this.tableData.total = res.data.total;
          this.seeDetailList = rec;
        });
    },
    // 购买完调用
    addSure(row) {
      let data = { id: row.id };
      this.$axios.post("/app/source_courseware_storage/buy", data).then(res => {
        if (res.code == 1) {
          this.$Message.success("购买成功");
          this.getCourseStore(this.tableData.current_page);
        } else {
          this.$Message.info(res.msg);
        }
      });
    },
    //  购买课件
    seeCourse(row) {
      this.$refs.detailModal.getDetail(row);
    }
  }
};
</script>
<style scoped lang="less">
.group-name:nth-child(n + 2)::before {
  content: " / ";
}
</style>
